import { afficherDecimal } from '@/helpers/utils'

export default function mettreVirgule (valeur) {
  return afficherDecimal(valeur);
}
